<div class="overlay">
    <div class="spinner-wrapper">
        <div class="spinner-border" role="status"></div>
    </div>
</div>
